module.exports = __webpack_public_path__ + "static/img/newsll.b68c6bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsll.png
// module id = l/SA
// module chunks = 45